export default __webpack_public_path__ + "134e4602450249d26bd70fac55348e13.png";